import {
  ICheckCreditMemoDocumentNumberRepository,
  ICheckCreditMemoDocumentNumberResponse,
} from "@/core/repositories/accounting";

export class CheckCreditMemoDocumentNumberUseCase {
  constructor(private readonly repository: ICheckCreditMemoDocumentNumberRepository) {}

  async execute(documentNumber: string): Promise<ICheckCreditMemoDocumentNumberResponse> {
    const normalizedDocumentNumber = documentNumber.trim();
    if (!normalizedDocumentNumber) {
      return { exists: false, documentNumber: normalizedDocumentNumber };
    }

    return this.repository.checkCreditMemoDocumentNumber({ documentNumber: normalizedDocumentNumber });
  }
}
